import { useQuery } from '@tanstack/react-query'

export default function useTransparency() {
  const { data } = useQuery({
    queryKey: ['transparency'],
    queryFn: async () => {
      const response = await (await fetch('https://data.decentraland.vote/api.json')).json()

      return response
    },
  })

  return data
}

type Detail = {
  name: string
  value: number
  description: string
}

type MonthlyTotal = {
  total: number
  previous: number
  details: Detail[]
}

type Member = {
  avatar: string
  address: string
  name: string
}

enum CommitteeName {
  SAB = 'Security Advisory Board',
  Council = 'DAO Council',
  WearableCuration = 'Wearable Curation Committee',
}

type Committee = {
  name: CommitteeName
  size: number
  description: string
  members: Member[]
}

type TokenInWallet = {
  symbol: string
  contractAddress: string
  amount: number
  quote: number
  name: string
  network: string
  address: string
  timestamp: Date
  rate: number
}

export type TransparencyData = {
  balances: TokenInWallet[]
  income: MonthlyTotal
  expenses: MonthlyTotal
  funding: {
    total: number
    budget: number
  }
  committees: Committee[]
}

export function useTransparencyV2() {
  const { data, isLoading: isLoadingTransparencyData } = useQuery({
    queryKey: ['transparencyData'],
    queryFn: async () => {
      const response = (await (
        await fetch('https://decentraland-dao.github.io/transparency/api-v2.json')
      ).json()) as TransparencyData
      return response
    },
  })

  return { data, isLoadingTransparencyData }
}

export function useTransparencyBalances() {
  const { data, isLoading: isLoadingTransparencyBalances } = useQuery({
    queryKey: ['transparencyBalances'],
    queryFn: async () => {
      const response = (await (
        await fetch('https://decentraland-dao.github.io/transparency/balances.json')
      ).json()) as TokenInWallet[]
      return response
    },
  })

  return { data, isLoadingTransparencyBalances }
}
